import React, { useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import TitleBox from '../../components/title-box'
import { FormattedMessage } from 'react-intl'

export default props => {
    useStyles(classes)
    const { payMethodInfo, shippingDetail, accountNo } = props

    return <TitleBox title={<FormattedMessage id="payment_method" defaultMessage="Payment Methods" />}>
        <div className={classes.Container}>
            <span className={classes.Label}>
                <span className={classes.Icon}>
                    <img src={payMethodInfo?.icon} />
                </span>
                <span className={classes.Title}>
                    {payMethodInfo?.name}
                </span>
            </span>

            {
                accountNo && <p className={classes.AccountNo}>{accountNo}</p>
            }
            
            <div className={classes.ZipCode}>
                <span><FormattedMessage id="zip_code" defaultMessage="Zip Code / Postal Code" />: </span>
                <span>{shippingDetail?.zipCode}</span>
            </div>
        </div>
    </TitleBox>
}